<template>
  <SessionSlide
    ref="slide"
    :id="'slide' + props.index"
    visual-position="fixed"
    :class="{
      'slide-after-activity': !isDisplayed,
      'submitted-mapping': isDisplayed,
    }"
    :data-test="`session-slide-${index}`"
    text-position="hidden"
  >
    <template #visual>
      <VisualPositioningCanvas v-if="!!lottieSrc" :is-full-screen="true">
        <CmsLottieAnimation
          ref="visual"
          :id="'lottie-' + props.index"
          :container-id="'slide' + props.index"
          :src="lottieSrc"
          :reverse-src="props.reverseLottieUrl"
        />
      </VisualPositioningCanvas>
    </template>
  </SessionSlide>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import SessionSlide from "../../sessions/session-slide.vue";
import VisualPositioningCanvas from "../../sessions/visual-positioning-canvas.vue";
import CmsLottieAnimation from "../cms-lottie-animation.vue";
import { CmsSessionSlideWithFullScreenLottie } from "../../../services/cms/cms-type-definitions";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import { useToggle } from "../../../composables/useToggle";

const props = defineProps<{
  slice: PrismicSliceWithData;
  reverseLottieUrl?: string;
  index: number;
}>();

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

const prismicSlice = computed<CmsSessionSlideWithFullScreenLottie>(() => {
  return props.slice.prismicSlice as CmsSessionSlideWithFullScreenLottie;
});

const lottieSrc = computed(() => prismicSlice.value.primary.lottie_file.url);

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

const visual = ref<InstanceType<typeof CmsLottieAnimation> | null>(null);
const slide = ref<SessionSlide | null>(null);
const visualDiv = computed(() => slide?.value?.visualDiv);

defineExpose({
  visualDiv,
  visual,
  slide,
});
</script>
